import { render, staticRenderFns } from "./NotAccepting.vue?vue&type=template&id=9670e720&"
import script from "./NotAccepting.vue?vue&type=script&lang=js&"
export * from "./NotAccepting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports